<template>
    <div class="layout">
      <CrudIntParentDetail />
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import CrudIntParentDetail from "@/components/components-planning/admin/int-parent/detail/CrudIntParentDetail.vue";
  
  export default {
    components: {
        CrudIntParentDetail,
    },
};
  </script>
  
  <style lang="scss" scoped>
  .layout {
    margin: 0 1rem;
    display: flex;
    justify-content: center;
    width: 100%;
  }
  </style>
  